import { RightOutlined } from '@ant-design/icons'
import { Flex } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import '../../../pages/aopsCase/caseTrackBoard.scss'
const CaseTrackBoardCard = ({
  caseTitle,
  emojiText,
  caseWorkId,
  process,
  onClickDetail,
}) => {
  const navigate = useNavigate()
  const goToCaseDetail = (caseWorkId, step) => {
    // step이 있으면 ?step=WAIT 형식으로, 없으면 그냥 이동
    const queryString = step ? `?step=${step}` : ''
    navigate(`/case/${caseWorkId}${queryString}`)
  }

  const returnSatusText = {
    OCCURRED: '발생',
    WAIT: '대기',
    COMPLETE: '완료',
  }

  return (
    <div className="case-track-card">
      <div className="content-header">
        <p className="title">
          {emojiText && `${emojiText} `}
          {caseTitle}
        </p>
        <Flex
          align="center"
          gap={4}
          style={{ cursor: 'pointer' }}
          onClick={onClickDetail}
        >
          <p className="more-text">더보기</p>
          <RightOutlined className="more-icon" />
        </Flex>
      </div>
      <div className="content-body">
        <Flex align="center" className="workflow-flow">
          {process?.map((item, index) => {
            const hasProblem =
              item?.waitProblemCount &&
              item?.waitProblemCount?.overdueWaitCount > 0
            return (
              <React.Fragment key={index}>
                <div
                  style={{ cursor: 'pointer' }}
                  className={
                    hasProblem ? 'workflow-stage' : 'workflow-stage no-issue'
                  }
                  onClick={() => goToCaseDetail(caseWorkId, item.step)} // 클릭 시 해당 step 전달
                >
                  <div className="stage-number">{item.issueCount}</div>
                  <div className="stage-label">{item.title}</div>
                  {hasProblem && (
                    <>
                      <div
                        className="stage-sub-status"
                        style={{ cursor: 'pointer !important' }}
                      >
                        <span className="sub-status-total">
                          {item?.waitProblemCount?.overdueWaitCount}
                        </span>
                      </div>
                    </>
                  )}
                </div>
                {index !== process?.length - 1 && (
                  <RightOutlined className="workflow-arrow" />
                )}
              </React.Fragment>
            )
          })}
        </Flex>
      </div>
    </div>
  )
}

export default CaseTrackBoardCard
